import React, {Component, PropTypes} from 'react';
import {observer, inject} from 'mobx-react';
import {observable, autorun, action, computed, toJS} from 'mobx';
import Spinner from '../Spinner';
import DataTable from '../DataTable';
import HierTable from '../HierTable';
import {Link} from 'react-router';

@inject('dataSourceStore', 'dataOriginParameterStore', 'dataOriginStore')
@observer
class DataSourceOriginList extends Component {
  static propTypes = {
    route: PropTypes.shape().isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    dataSourceStore: PropTypes.object.isRequired,
  };

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  disposer = null;

  @observable dataSource = {};

  componentWillMount() {
    const {params: {id}, dataSourceStore} = this.props;

    this.disposer = autorun(() => {
      const foundDataSource = dataSourceStore.findById(id);
      this.resetInputValues(foundDataSource);
    });
  }

  componentWillReceiveProps(nextProps) {
    const {params: {id}, dataSourceStore} = nextProps;
    if (id !== this.props.params.id) {
      this.disposer = autorun(() => {
        const foundDataSource = dataSourceStore.findById(id);
        this.resetInputValues(foundDataSource);
      });
    }
  }

  componentWillUnmount() {
    this.disposer();
  }

  flattenTableData(dataArray) {
    const {params: {id}} = this.props;
    let arr = [];

    if (dataArray) {
      dataArray.forEach(dataOrigin => {
        arr.push({
          type: 'DATA_ORIGIN',
          level: 1,
          key: dataOrigin.id,
          slug: `/daq/data-source/${id}/data-origin`,
          childSlug: `/daq/data-source/${id}/data-origin/${dataOrigin.id}/data-origin-parameter`,

          id: dataOrigin.id,
          code: `${dataOrigin.code}${+dataOrigin.block === 1 ? ' [BLOCKED]' : ''}`,
          timezone: dataOrigin.timezone,
          // stations: dataOrigin.stations && dataOrigin.stations[0].name,
          stations: (
            <ul>
              {dataOrigin.stations && dataOrigin.stations.map(station => (
                <li key={`${dataOrigin.id}-${station.id}`}>
                  <Link to={`/station/${station.id}`}>{station.name}</Link>
                </li>
              ))}
            </ul>
          ),
        });

        if (dataOrigin.data_origin_parameters) {
          let temp = []
          dataOrigin.data_origin_parameters.forEach(dataOriginParameter => {
            temp.push({
              type: 'DATA_ORIGIN_PARAMETER',
              level: 2,
              key: `${dataOrigin.id}.${dataOriginParameter.id}`,
              slug: `/daq/data-source/${id}/data-origin/${dataOrigin.id}/data-origin-parameter`,

              id: dataOriginParameter.id,
              // code: dataOriginParameter.code,
              code: `${dataOriginParameter.code}${+dataOriginParameter.block === 1 ? ' [BLOCKED]' : ''}`,
              timezone: dataOriginParameter.parameter_name,
              stations: null,
              parent_id: dataOrigin.id,
            });
          });
          arr = [...arr, ...temp.sort((a, b) => a.code < b.code ? 1 : -1)];
        }
      });
    }

    return arr;
  }

  @computed get tableData() {
    const origins = this.dataSource.origins || [];
    return this.flattenTableData(origins);
  }

  @action
  resetInputValues(item) {
    if (!item) {
      return;
    }
    this.dataSource = item.asJson;
  }

  columns = [
    {key: 'code', label: 'Device Code', colClassName: 'level-2-indent-left'},
    {key: 'timezone', label: 'Timezone'},
    {key: 'stations', label: 'Mapped To'},
  ];

  @action handleDelete = async(idOrIds, type) => {
    const {params:{id}, dataSourceStore, dataOriginParameterStore, dataOriginStore} = this.props;
    const {notify} = this.context;

    try{
      if (type === 'DATA_ORIGIN_PARAMETER') {
        let res = await dataOriginParameterStore.removeItems(idOrIds);
        if (res.removed) {
          let dataOrigin = dataSourceStore.findById(id).origins;
          let reqDOId = null;
          dataOrigin.map(dO => {
            if(!!dO.data_origin_parameters) dO.data_origin_parameters.map(dop => {
              if (!reqDOId && dop.id == idOrIds) {
                reqDOId = dO.id;
              }
            })
          });
          let dops = dataSourceStore.items.filter(ds => ds.id == id)[0].origins.filter(dOrgn => dOrgn.id == reqDOId)[0].data_origin_parameters;
          let selectedDop = dops.filter(dop => dop.id == idOrIds)[0];
          dataSourceStore.items.filter(ds => ds.id == id)[0].origins.filter(dOrgn => dOrgn.id == reqDOId)[0].data_origin_parameters.splice(dops.indexOf(selectedDop), 1);
          notify.success({message: 'data origin parameter deleted'});
        }
      }
      if (type === 'DATA_ORIGIN') {
        let dop = dataSourceStore.findById(id).origins.find(o => +o.id === +idOrIds).data_origin_parameters;
        // if(dop && dop.length) {
        //   this.context.notify.error({message: 'Data origin contains origin parameters'});
        //   return;
        // }
        let res = await dataOriginStore.removeItems(idOrIds);
        if (res.removed) {
          let origins = dataSourceStore.items.filter(ds => ds.id == id)[0].origins;
          let selectedOrigin = origins.filter(ds => ds.id == idOrIds)[0];
          dataSourceStore.items.filter(ds => ds.id == id)[0].origins.splice(origins.indexOf(selectedOrigin), 1);
          notify.success({message: 'data origin deleted'});
        }
      }
      this.forceUpdate();
    } catch (err) {
      console.log(err);
      notify.error({message: err.toString()});
    }
  };

  render() {
    const {
      dataSourceStore,
      params: {id},
      children,
    } = this.props;

    if (dataSourceStore.isLoading) {
      return <Spinner />;
    }

    let dataSource = dataSourceStore.findById(id);

    return (
      <div>
        <HierTable
          caption={`${dataSource.name} Data Origins`}
          data={this.flattenTableData(dataSourceStore.findById(id).origins.sort((a, b) => a.code < b.code ? 1 : -1))}
          columns={this.columns}
          slug={`daq/data-source/${id}/data-origin`}
          parentSlug={`/daq/data-source/${id}`}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resources={{parent: 'data-origin', child: 'data-origin-parameter'}}
        />
        <div>
          {children}
        </div>
      </div>
    );
  }
}

export default DataSourceOriginList;



// WEBPACK FOOTER //
// ./src/components/DataSource/DataSourceOriginList.js